export enum MeasurementUnit {
  g = '1',
  kg = '2',
  ml = '3',
  lt = '4',
  each = '5',
}

export enum PriceDisplayUnitEnum {
  PoundPerGr = '1',
  PoundPerKg = '2',
  PoundPerLitre = '3',
  PoundForEach = '4',
  PoundPerCase = '5',
}

export enum WeightTypeEnum {
  FixedWeight = '1',
  GuideWeight = '2',
}

const measurementUnitLabels: Record<MeasurementUnit, string> = {
  [MeasurementUnit.g]: 'Gram',
  [MeasurementUnit.kg]: 'Kilogram',
  [MeasurementUnit.ml]: 'Milliliter',
  [MeasurementUnit.lt]: 'Liter',
  [MeasurementUnit.each]: 'Each',
};

export const getMeasurementunitLabel = (unit: string): string =>
  measurementUnitLabels[unit as MeasurementUnit] || '';

export const priceDisplayUnitLabels: Record<PriceDisplayUnitEnum, string> = {
  [PriceDisplayUnitEnum.PoundPerGr]: '/gram',
  [PriceDisplayUnitEnum.PoundPerKg]: '/kg',
  [PriceDisplayUnitEnum.PoundPerLitre]: '/liter',
  [PriceDisplayUnitEnum.PoundForEach]: '/pounf',
  [PriceDisplayUnitEnum.PoundPerCase]: '/case',
};

export const getPriceDisplayUnitLabel = (unit: string): string =>
  priceDisplayUnitLabels[unit as PriceDisplayUnitEnum] || '';

export const weightTypeLabels: Record<WeightTypeEnum, string> = {
  [WeightTypeEnum.FixedWeight]: 'Fixed Weight',
  [WeightTypeEnum.GuideWeight]: 'Guide Weight',
};
